"use client";

import { useEffect } from "react";

import { useAuth } from "@/contexts/auth-context";
import i18n from "@/i18n";

export function LanguageInitializer() {
  const { profile, isInitialized } = useAuth();

  useEffect(() => {
    if (!isInitialized) return;

    // Initialize language when auth is ready
    const initializeLanguage = async () => {
      let targetLanguage = "en"; // default

      // Priority 1: Get language from user profile (/me endpoint)
      if (profile?.language) {
        targetLanguage = profile.language;

      } else {
        // Priority 2: Get language from localStorage
        if (typeof window !== "undefined") {
          const storedLanguage = localStorage.getItem("i18nextLng");
          if (storedLanguage && (storedLanguage === "en" || storedLanguage === "ja")) {
            targetLanguage = storedLanguage;

          } else {
            // Priority 3: Get language from browser
            const browserLang = navigator.language || navigator.languages?.[0] || "";
            if (browserLang.toLowerCase().includes("ja")) {
              targetLanguage = "ja";

            } else {
              // Priority 4: Fallback to 'en'
              targetLanguage = "en";

            }
          }
        }
      }

      // Update localStorage
      if (typeof window !== "undefined") {
        localStorage.setItem("i18nextLng", targetLanguage);
      }

      // Force i18n to change language immediately
      try {
        // Wait a bit to ensure i18n is ready
        await new Promise(resolve => setTimeout(resolve, 100));

        await i18n.changeLanguage(targetLanguage);


        // Trigger a custom event to notify other components
        if (typeof window !== "undefined") {
          window.dispatchEvent(new CustomEvent("languageChanged", {
            detail: { language: targetLanguage }
          }));
        }
      } catch (error) {
        console.error("Failed to change i18n language:", error);
      }
    };

    initializeLanguage();
  }, [profile, isInitialized]);

  // This component doesn't render anything
  return null;
}
